var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "left-box",
          attrs: {
            "body-style":
              "height:calc(100vh - 70px);overflow-y:auto;padding:0px 20px;padding-bottom: 0px",
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                height: "40px",
                display: "flex",
                "font-size": "18px",
                "font-weight": "bold",
                "align-items": "center",
              },
            },
            [
              _c("div", { staticStyle: { color: "#000" } }, [
                _c(
                  "span",
                  {
                    staticStyle: { cursor: "pointer" },
                    on: {
                      click: function ($event) {
                        return _vm.$router.push(
                          "/ProjectInfo/ProjectAll?id=" + _vm.$route.query.id
                        )
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.backName || "工作台"))]
                ),
                _c("i", { staticClass: "el-icon-arrow-right" }),
              ]),
              _c(
                "div",
                { staticClass: "ellipsis", staticStyle: { color: "#606266" } },
                [_vm._v("供应商统计")]
              ),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "df",
            },
            [
              _c(
                "el-card",
                { staticStyle: { height: "110px", width: "20%" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "wh100",
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        "flex-wrap": "wrap",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "projectText ellipsis",
                          staticStyle: { width: "100%" },
                          attrs: { title: _vm.SupplierInfo.Code },
                        },
                        [
                          _vm._v(
                            " 供应商名称：" +
                              _vm._s(_vm.SupplierInfo.cVenName) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "projectText ellipsis",
                          staticStyle: { width: "100%" },
                          attrs: { title: _vm.SupplierInfo.cVenPerson },
                        },
                        [
                          _vm._v(
                            " 联系人：" +
                              _vm._s(_vm.SupplierInfo.cVenPerson) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "projectText ellipsis",
                          staticStyle: { width: "100%" },
                          attrs: { title: _vm.SupplierInfo.cVenPhone },
                        },
                        [
                          _vm._v(
                            " 联系人手机号：" +
                              _vm._s(_vm.SupplierInfo.cVenPhone) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _c(
                "el-card",
                {
                  staticStyle: {
                    height: "110px",
                    width: "250px",
                    position: "relative",
                  },
                  attrs: {
                    "body-style": {
                      padding: 0,
                    },
                  },
                },
                [
                  _c("div", {
                    staticStyle: {
                      width: "100%",
                      height: "calc(100%)",
                      "margin-top": "30px",
                    },
                    attrs: { id: "DeviceProgress" },
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        height: "30px",
                        width: "100%",
                        position: "absolute",
                        top: "0",
                        left: "0",
                        "text-align": "center",
                        "font-weight": "bold",
                        "font-size": "18px",
                        "line-height": "30px",
                      },
                    },
                    [
                      _vm._v(" 提交率"),
                      _vm.SupplyType == "1"
                        ? _c("span", { staticClass: "hint-text" }, [
                            _vm._v("(乙供+分包)"),
                          ])
                        : _vm._e(),
                      _vm.SupplyType == "3"
                        ? _c("span", { staticClass: "hint-text" }, [
                            _vm._v("(甲供)"),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
              _c(
                "el-card",
                {
                  staticStyle: {
                    height: "110px",
                    width: "250px",
                    position: "relative",
                  },
                  attrs: {
                    "body-style": {
                      padding: 0,
                    },
                  },
                },
                [
                  _c("div", {
                    staticStyle: {
                      width: "100%",
                      height: "calc(100%)",
                      "margin-top": "30px",
                    },
                    attrs: { id: "DocumentProgress" },
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        height: "30px",
                        width: "100%",
                        position: "absolute",
                        top: "0",
                        left: "0",
                        "text-align": "center",
                        "font-weight": "bold",
                        "font-size": "18px",
                        "line-height": "30px",
                      },
                    },
                    [
                      _vm._v(" 通过率"),
                      _vm.SupplyType == "1"
                        ? _c("span", { staticClass: "hint-text" }, [
                            _vm._v("(乙供+分包)"),
                          ])
                        : _vm._e(),
                      _vm.SupplyType == "3"
                        ? _c("span", { staticClass: "hint-text" }, [
                            _vm._v("(甲供)"),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    height: "110px",
                    width: "calc(80% - 500px)",
                    display: "flex",
                  },
                },
                [
                  _c(
                    "el-card",
                    {
                      staticStyle: { width: "25%", height: "100%" },
                      attrs: { "body-style": "padding: 0px 10px" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "wh100 df aic juc",
                          staticStyle: { padding: "0px 5px" },
                        },
                        [
                          _c("div", { staticClass: "leftNum" }, [
                            _c(
                              "div",
                              {
                                staticClass: "ellipsis num w100 tac",
                                attrs: {
                                  title: `${Math.round(
                                    Number(_vm.dataStatistics.DeviceSubQty || 0)
                                  )}/${Math.round(
                                    Number(_vm.dataStatistics.DeviceQty || 0)
                                  )}`,
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "font-size": "18px" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        Math.round(
                                          Number(
                                            _vm.dataStatistics.DeviceSubQty || 0
                                          )
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(
                                  "/" +
                                    _vm._s(
                                      Math.round(
                                        Number(
                                          _vm.dataStatistics.DeviceQty || 0
                                        )
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c("div", { staticClass: "w100 tac" }, [
                              _c(
                                "span",
                                { staticStyle: { "font-size": "12px" } },
                                [_vm._v("提交数/总数")]
                              ),
                            ]),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "rightNum",
                              staticStyle: { color: "#e6a23c" },
                            },
                            [
                              _c("div", { staticClass: "w100 tac" }, [
                                _c("i", {
                                  staticClass: "icon-shebei icon",
                                  staticStyle: {
                                    color: "#e6a23c",
                                    "font-size": "24px",
                                  },
                                }),
                              ]),
                              _c("div", { staticClass: "w100 tac" }, [
                                _vm._v("设备"),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "el-card",
                    {
                      staticStyle: { width: "25%", height: "100%" },
                      attrs: { "body-style": "padding: 0px 10px" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "wh100 df aic juc",
                          staticStyle: { padding: "0px 10px" },
                        },
                        [
                          _c("div", { staticClass: "leftNum" }, [
                            _c(
                              "div",
                              {
                                staticClass: "ellipsis num w100 tac",
                                attrs: {
                                  title: `${Math.round(
                                    Number(
                                      _vm.dataStatistics.SupplierSubQty || 0
                                    )
                                  )}/${Math.round(
                                    Number(_vm.dataStatistics.SupplierQty || 0)
                                  )}`,
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "font-size": "18px" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        Math.round(
                                          Number(
                                            _vm.dataStatistics.SupplierSubQty ||
                                              0
                                          )
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(
                                  "/" +
                                    _vm._s(
                                      Math.round(
                                        Number(
                                          _vm.dataStatistics.SupplierQty || 0
                                        )
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c("div", { staticClass: "w100 tac" }, [
                              _c(
                                "span",
                                { staticStyle: { "font-size": "12px" } },
                                [_vm._v("提交数/总数")]
                              ),
                            ]),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "rightNum",
                              staticStyle: { color: "#bfa170" },
                            },
                            [
                              _c("div", { staticClass: "w100 tac" }, [
                                _c("i", {
                                  staticClass: "icon-gongyingshang1 icon",
                                  staticStyle: { "font-size": "24px" },
                                }),
                              ]),
                              _c("div", { staticClass: "w100 tac" }, [
                                _vm._v("供应商"),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "el-card",
                    {
                      staticStyle: { width: "25%", height: "100%" },
                      attrs: { "body-style": "padding: 0px 10px" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "wh100 df aic juc",
                          staticStyle: { padding: "0px 10px" },
                        },
                        [
                          _c("div", { staticClass: "leftNum" }, [
                            _c(
                              "div",
                              {
                                staticClass: "ellipsis num w100 tac",
                                attrs: {
                                  title: `${Math.round(
                                    Number(_vm.dataStatistics.DataSubData || 0)
                                  )}/${Math.round(
                                    Number(_vm.dataStatistics.DataQty || 0)
                                  )}`,
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "font-size": "18px" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        Math.round(
                                          Number(
                                            _vm.dataStatistics.DataSubData || 0
                                          )
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(
                                  "/" +
                                    _vm._s(
                                      Math.round(
                                        Number(_vm.dataStatistics.DataQty || 0)
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c("div", { staticClass: "w100 tac" }, [
                              _c(
                                "span",
                                { staticStyle: { "font-size": "12px" } },
                                [_vm._v("提交数/总数")]
                              ),
                            ]),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "rightNum",
                              staticStyle: { color: "#409eff" },
                            },
                            [
                              _c("div", { staticClass: "w100 tac" }, [
                                _c("i", {
                                  staticClass: "el-icon-tickets",
                                  staticStyle: { "font-size": "24px" },
                                }),
                              ]),
                              _c("div", { staticClass: "w100 tac" }, [
                                _vm._v("资料"),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "el-card",
                    {
                      staticStyle: { width: "25%", height: "100%" },
                      attrs: { "body-style": "padding: 0px 10px" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "wh100 df aic juc",
                          staticStyle: { padding: "0px 10px" },
                        },
                        [
                          _c("div", { staticClass: "leftNum" }, [
                            _c(
                              "div",
                              {
                                staticClass: "ellipsis num w100 tac",
                                attrs: {
                                  title: `${Math.round(
                                    Number(
                                      _vm.dataStatistics.SparePartsSubQty || 0
                                    )
                                  )}/${Math.round(
                                    Number(
                                      _vm.dataStatistics.SparePartsQty || 0
                                    )
                                  )}`,
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "font-size": "18px" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        Math.round(
                                          Number(
                                            _vm.dataStatistics
                                              .SparePartsSubQty || 0
                                          )
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(
                                  "/" +
                                    _vm._s(
                                      Math.round(
                                        Number(
                                          _vm.dataStatistics.SparePartsQty || 0
                                        )
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c("div", { staticClass: "w100 tac" }, [
                              _c(
                                "span",
                                { staticStyle: { "font-size": "12px" } },
                                [_vm._v("提交数/总数")]
                              ),
                            ]),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "rightNum",
                              staticStyle: { color: "#6bc1c1" },
                            },
                            [
                              _c("div", { staticClass: "w100 tac" }, [
                                _c("i", {
                                  staticClass: "el-icon-menu",
                                  staticStyle: { "font-size": "24px" },
                                }),
                              ]),
                              _c("div", { staticClass: "w100 tac" }, [
                                _vm._v("配件"),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-card",
            {
              staticStyle: {
                width: "100%",
                "margin-top": "10px",
                "box-sizing": "border-box",
              },
              attrs: { "body-style": "padding: 0px 10px" },
            },
            [
              _c(
                "el-tabs",
                {
                  staticStyle: { height: "100%" },
                  model: {
                    value: _vm.tabsStatistics,
                    callback: function ($$v) {
                      _vm.tabsStatistics = $$v
                    },
                    expression: "tabsStatistics",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "工作统计", name: "Statistics" } },
                    [
                      _c(
                        "el-card",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.ProjectCountLoading,
                              expression: "ProjectCountLoading",
                            },
                          ],
                          staticStyle: {
                            width: "100%",
                            height: "250px",
                            position: "relative",
                            padding: "0px 10px",
                          },
                          attrs: {
                            "body-style": {
                              padding: 0,
                            },
                          },
                        },
                        [
                          _c("div", {
                            staticStyle: {
                              width: "100%",
                              height: "calc(100%)",
                            },
                            attrs: { id: "DocumentBar" },
                          }),
                        ]
                      ),
                      _vm.SupplyType == "1"
                        ? _c(
                            "el-card",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.SupplierCountLoading,
                                  expression: "SupplierCountLoading",
                                },
                              ],
                              staticStyle: {
                                width: "100%",
                                position: "relative",
                                padding: "20px",
                                "min-height": "400px",
                              },
                              attrs: {
                                "body-style":
                                  "padding: 0px;width:100%;height:100%",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    height: "30px",
                                    position: "absolute",
                                    top: "20px",
                                    left: "20px",
                                    "text-align": "center",
                                    "font-weight": "bold",
                                    "font-size": "18px",
                                    "line-height": "30px",
                                  },
                                },
                                [
                                  _vm._v(" 供应商提交率/通过率"),
                                  _c("span", { staticClass: "hint-text" }, [
                                    _vm._v("(乙供+分包)"),
                                  ]),
                                ]
                              ),
                              _c("div", {
                                style: {
                                  width: "100%",
                                  height: _vm.supplierBarHeight + "px",
                                },
                                attrs: { id: "SupplierBar" },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "设备信息清单", name: "sb" } },
                    [
                      _vm.tabsStatistics === "sb"
                        ? _c("ScheduleList", { ref: "ScheduleList" })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "设备资料清单", name: "zl" } },
                    [
                      _vm.tabsStatistics === "zl"
                        ? _c("ScheduleDocument", { ref: "ScheduleDocument" })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "配件清单", name: "bj" } },
                    [
                      _vm.tabsStatistics === "bj"
                        ? _c("Spare", { ref: "Spare" })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "资质清单", name: "zz" } },
                    [
                      _vm.tabsStatistics === "zz"
                        ? _c("TeamAudiList", { ref: "TeamAudiList" })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.SupplyType == "1"
                    ? _c(
                        "el-tab-pane",
                        { attrs: { label: "项目资料清单", name: "xm" } },
                        [
                          _vm.tabsStatistics === "xm"
                            ? _c("ProjectDocumentList", {
                                ref: "ProjectDocumentList",
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }